export default __webpack_public_path__ + "static/media/SWT0550.34I-20670_-23130_0.5dcecd35.jpg";